import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import '../../i18n';
import LoadingPage from '../../pages/LoadingPage';
import NotFoundPage from '../../pages/NotFoundPage';
import ReferralPanelPage from '../../pages/ReferralPanelPage';

const Router = (): JSX.Element => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={`/`} element={<Navigate to="/it" replace={true} />} />
        <Route path={`/:locale/`} element={<ReferralPanelPage />} />
        <Route
          path={`/promo/:invitationCode`}
          element={<LoadingPage title="Redirecting..." />}
        />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
